import { atom, useAtom } from 'jotai';

export const hashCodeAtom = atom('');
const useHashCodeAtom = () => useAtom(hashCodeAtom);

// 一時的なトークン保存用のAtom（Join処理完了後にクリア）
const loggedInTokenAtom = atom('');
const useLoggedInTokenAtom = () => useAtom(loggedInTokenAtom);

// サインアップフォームの入力情報を保存するAtom
type SignUpFormData = {
  email: string;
  birthday: string;
  gender: string;
  mailNews: string;
};

export const signUpFormInitialData: SignUpFormData = {
  email: '',
  birthday: '',
  gender: 'they',
  mailNews: 'yes',
};

export const signUpFormDataAtom = atom<SignUpFormData>(signUpFormInitialData);

const useSignUpFormDataAtom = () => useAtom(signUpFormDataAtom);

export { useHashCodeAtom, useLoggedInTokenAtom, useSignUpFormDataAtom };
